module.exports = __webpack_public_path__ + "static/media/c16-connect.6db93ead.png";